module.exports = __webpack_public_path__ + "arrow-left.26116b0aaa3463a8382b.svg";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/icon/arrow-left.svg
// module id = ../../../../../src/img/icon/arrow-left.svg
// module chunks = styles